var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssociatesTotalNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    transform: "translate(0 0)",
    fill: "#73a91b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-353 -472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0c50,0,50,0,50,50s0,50-50,50S0,100,0,50,0,0,50,0Z",
    transform: "translate(353 472)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357 475.955)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.045)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1,28.005A45.866,45.866,0,0,0,3.6,63.7q.814,1.926,1.795,3.756a22.364,22.364,0,0,1,.937-2.75A43.787,43.787,0,1,1,89.642,45.854a43.529,43.529,0,0,1-4.271,18.854,22.381,22.381,0,0,1,.938,2.75q.978-1.83,1.795-3.755a46,46,0,0,0,0-35.7",
    transform: "translate(0 -0.029)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.812,236.891a7.389,7.389,0,1,0-7.389,7.389,7.389,7.389,0,0,0,7.389-7.389",
    transform: "translate(-300.624 -189.555)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.212,304.787a12.344,12.344,0,0,0-10.2,4.826c2.524,4.467,3.008,15.613,3.008,15.613s-1.508-11.146-3.882-15.613c-2.325-4.374-6.49-8.7-13.871-8.7s-11.546,4.329-13.871,8.7c-2.374,4.467-3.882,15.613-3.882,15.613S62,314.08,64.522,309.613a12.344,12.344,0,0,0-10.2-4.826c-8.693,0-12.012,6.9-13.218,11.015a18.836,18.836,0,0,0-.643,2.987l0,0a45.883,45.883,0,0,0,77.607,0l0,0a18.82,18.82,0,0,0-.643-2.987c-1.206-4.113-4.525-11.015-13.218-11.015",
    transform: "translate(-33.413 -248.525)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,236.891a7.389,7.389,0,1,0-7.389,7.389,7.389,7.389,0,0,0,7.389-7.389",
    transform: "translate(-64.097 -189.555)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.378,199.872h0a9.464,9.464,0,1,0-9.464-9.464A9.464,9.464,0,0,0,218.378,199.872Z",
    transform: "translate(-172.524 -149.455)",
    fill: "#73a91b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociatesTotalNumber);
export default __webpack_public_path__ + "static/media/Associates-Total-Number.c888b99341ae3130c5a38790c36ca121.svg";
export { ForwardRef as ReactComponent };